import { createContext, useContext } from "react";

import { Channel } from "@/types/Channel";

export type ChannelContextType = {
  channel?: Channel;
  updateChannel: (channel: Partial<Channel>) => void;
};

const ChannelContext = createContext<ChannelContextType>(
  {} as ChannelContextType
);

export default ChannelContext;

export const useChannel = () => useContext(ChannelContext);
